import React from 'react';
import { motion } from 'framer-motion';
import { WhatsAppButton } from './WhatsAppButton';
export function FinalCTASection() {
  return <section className="py-32 px-4 relative overflow-hidden bg-darkCard" data-id="element-18">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-whatsapp/5 blur-[150px] rounded-full pointer-events-none" data-id="element-19" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-20">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-display text-4xl md:text-6xl font-extrabold mb-8 leading-tight text-white" data-id="element-21">
          Entrá al grupo, mirá los horarios y empezá a vender tus ebooks
          digitales
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col items-center gap-4" data-id="element-22">
          <WhatsAppButton className="w-full md:w-auto text-xl py-5 px-10" data-id="element-23">
            QUIERO ENTRAR AL GRUPO
          </WhatsAppButton>

          <p className="text-gray-400 font-semibold mt-4" data-id="element-24">
            ⚡ Acceso inmediato + info de horarios dentro del grupo
          </p>
        </motion.div>
      </div>
    </section>;
}